import './publication.less'
import m from 'mithril'
import ContentContainer from 'views/layout/contentcontainer'
import ContentPage from 'views/pages/contentpage'
import {ArticleType} from 'views/partials/features/articlelink'
import ArticlesContainer from 'views/partials/features/articlescontainer'
import {PublicationType} from 'views/partials/features/publicationlink'
import PublicationsContainer from 'views/partials/features/publicationscontainer'
import Spacer from 'views/partials/spacer'

export default class Publication extends ContentPage<{
	sector: Array<string>
	policy: Array<string>
	tags: Array<string>
	lists: any
	related: {publications: Array<PublicationType>; articles: Array<ArticleType>}
}> {
	viewContent() {
		const {related, lists, channel} = this.attrs.data
		return m('.publication-bottom',
			m(ContentContainer, {mod: 'publication'}, [
				m(Spacer),
				m(ArticlesContainer, {related, mod: 'pulicationdetail', channel}),
				m(PublicationsContainer, {
					related,
					mod: 'publication',
					allTags: lists.tags
				})
			])
		)
	}
}
